import { AxiosError } from 'axios';
import LogRocket from 'logrocket';

import * as Sentry from '@sentry/browser';
import { Storyblok } from '../../storyblok';

export interface ClientErrorData {
    category: 'General' | 'Altinn API' | 'Upscore API' | 'Firebase';
    error?: AxiosError;
    /**
     * This object used to gather all kind of data that might help us debug
     * problems in Sentry dashboard
     */
    extras?: { [key: string]: string };
    response?: any;
    /**
     * Allows to distinguish which error page to display.
     */
    type: Storyblok.Content.ErrorType;
}

export class ClientError extends Error {
    public data: ClientErrorData;

    constructor(message: string, data: ClientErrorData) {
        super(message);
        this.name = 'API Error';
        this.data = data;

        /**
         * Explicit check if there is a response data likely comming from
         * AXIOS requests
         */
        if (data.error && data.error.response && data.error.response.data) {
            this.data.response = data.error.response.data;
        }

        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ClientError);
        }

        LogRocket.getSessionURL((sessionURL) => {
            Sentry.withScope((scope) => {
                scope.setTag('category', this.data.category);
                for (const key in data.extras) {
                    if (this.data.extras) {
                        scope.setExtra(key, this.data.extras[key]);
                    }
                }
                scope.setExtra('sessionURL', sessionURL);
                Sentry.getCurrentHub().pushScope();
            });
        });
    }
}
